import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { config, ChildViewModel, AuthService, MembershipOptionQuery, MembershipOption, BalanceQuery } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'fgb-child-panel',
  templateUrl: 'child-panel.component.html',
  styleUrls: ['child-panel.component.scss'],
})
export class ChildPanelComponent implements OnInit, OnDestroy{
  membershipOption: MembershipOption[];
  loyaltyPointsCard$: Observable<number | undefined>;
  subscription: Subscription;

  constructor(
    private authService: AuthService,
    private membershipOptionQuery: MembershipOptionQuery,
    private balanceQuery: BalanceQuery,
    private modalService: NgbModal
  ) {}

  @Input() child: ChildViewModel;

  ngOnInit() {
    this.loyaltyPointsCard$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.subscription = this.membershipOptionQuery.selectAll().subscribe((options) => {
      this.membershipOption = options as MembershipOption[];
    });
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  loginToChild() {
    firstValueFrom(this.authService.switchUser(this.child.MemberId));
  }

  openChildBarcode(modal: any) {
    this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'child-barcode-modal',
      centered: true
    });
  }
}
